/**
 * Central place for site-wide extension points: analytics IDs, API base, blog settings.
 * Add new VITE_* keys in env.d.ts + .env.example when you wire more pixels or tools.
 */
export const siteConfig = {
  url: import.meta.env.VITE_SITE_URL || (typeof window !== "undefined" ? window.location.origin : ""),
  blog: {
    basePath: "/blog",
    title: "Journal",
  },
  analytics: {
    gtmContainerId: import.meta.env.VITE_GTM_CONTAINER_ID || "",
    metaPixelId: import.meta.env.VITE_META_PIXEL_ID || "",
    googleAdsId: import.meta.env.VITE_GOOGLE_ADS_ID || "",
    linkedInPartnerId: import.meta.env.VITE_LINKEDIN_PARTNER_ID || "",
  },
  api: {
    /** In dev, Vite proxies /api → Express. In prod, same origin or set VITE_API_URL if split. */
    base: "",
  },
} as const;
